/* eslint sort-keys: "error" */
/* eslint-env es6 */

import ArgosFeatures from './argos'

const TuClothingOnArgosFeatures = {
  ASK_QUESTION: true,
  ASK_TREVOR_ENABLED: true,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.argos.co.uk',
  BREADCRUMB: true,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: false,
  COMPARISON_ATTRIBUTES: true,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: true,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    ctaText: 'Email me',
    enabled: true,
    excludedSkus: [],
    position: 'sizePicker',
    proxyPath: ArgosFeatures?.EMAIL_ME_BACK?.proxyPath,
    source: 'web_pdp',
    trackOnLoad: false
  },
  ENERGY_SAVING: false,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: true,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  FULFILMENT_PASS: {
    SHOW_PRODUCT_ELIGIBILITY: false,
    SHOW_PURCHASE_PASS: false
  },
  GO_IN_STORE: false,
  KLARNA_CREDITPLAN: true,
  KLARNA_MESSAGING: {
    dcid:
      'klarna_live_client_MHMtVGopOFZRQShjZFNHYmREOUdWYVFyYURjTk8zWXAsMGM2NjYxYWQtZmU4MS00YWIwLTkxNTYtNzM0NjRjYzA2MGZhLDEsNFpoRFliRUVuTFBnc2NhaFgyUFZTQ1BPL0xBSjJUWkNEODFtUnNJQkxtTT0',
    enabled: true
  },
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: true,
  MONTHLY_PAYMENT_PLAN: false,
  NECTAR: true,
  PAYPAL_IFC_MESSAGING: false,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: false,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: true,
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: false,
  SHOW_ARGOSCARD_LOGO_FINANCE_ACCORDION: false,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: true,
  TEMPLATE_TYPE: 'TU_ON_ARGOS',
  WISHLIST: true
}

export default TuClothingOnArgosFeatures
